import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { message } from "antd";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import Styled from "../AddSectionStyles";
import { deleteAddSectionTextPC } from "../../../../../../store/service/proposalAndContractService";
import EditAddSectionTextModal from "./EditAddSectionTextModal";

import RemoveModal from "../../../../Commons/RemoveModal";
import Colors from "../../../../../../Constants/Colors";
import TextStyles from "../../../../../../Constants/TextStyles";

// import textBtn from "../../../../../../Assets/assetsnew/text-image-new.svg";

const Text = ({ data, pc_id }) => {
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);

  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const handleCloseRemoveModal = () => setShowRemoveModal(false);

  const deleteHandler = () => {
    const Obj = {
      pc_id: pc_id,
      _id: data._id,
      // position: position,
    };
    dispatch(deleteAddSectionTextPC(Obj)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        message.success(`${data.payload.message}`);
        setShowRemoveModal(false);
      } else {
        message.error(`${data.error.message}!`);
      }
    });
  };

  function PascalCase(str) {
    return str
      .split(' ') // Split into words
      .map(word => word.charAt(0).toUpperCase()+word.slice(1).toLowerCase()) // Capitalize first letter of each word
      .join(' ')
  }

  return (
    <>
      <Styled.ReviewBox>
        <div className="edit-delete-wrapper">
          <BorderColorOutlinedIcon
            onClick={() => setEditModal(true)}
            sx={{
              cursor: "pointer",
              color: Colors.font2,
              opacity: 0.8,
              "&:hover": {
                opacity: 1,
              },
            }}
          />
          <CloseOutlinedIcon
            onClick={() => {
              setShowRemoveModal(true);
              setConfirmDialog({
                onConfirm: () => deleteHandler(),
              });
            }}
            sx={{
              cursor: "pointer",
              color: Colors.font2,
              opacity: 0.8,
              marginLeft: 1,
              "&:hover": {
                opacity: 1,
              },
            }}
          />
        </div>

        <TextStyles.FontSize18px className="fw-medium mb-3">
          {PascalCase(data.text_title)}
        </TextStyles.FontSize18px>

        {/* <div className="d-flex align-items-center gap-2 gap-md-3 mb-4">
          <img
            src={textBtn}
            alt="textImageBtn"
            style={{ maxWidth: "2.2rem" }}
          />

          <TextStyles.FontSize18px className="fw-medium">
            Text
          </TextStyles.FontSize18px>
        </div> */}

        {/* <TextStyles.FontSize14px> */}
        {/* <div className="mb-2 fw-medium">Title</div>
          <Styled.Text className="mb-3">
            {data.text_title}
          </Styled.Text>

          <div className="mb-2 fw-medium">Description</div> */}
        {/* <Styled.Text>{data.textarea}</Styled.Text> */}
        <p className="m-0 lh-lg">{data.textarea}</p>
        {/* </TextStyles.FontSize14px> */}
      </Styled.ReviewBox>

      {editModal && (
        <EditAddSectionTextModal
          show={editModal}
          handleClose={() => setEditModal(false)}
          editData={data}
          // position={position}
          pc_id={pc_id}
        />
      )}

      <RemoveModal
        title="note"
        confirmDialog={confirmDialog}
        showRemoveModal={showRemoveModal}
        handleCloseRemoveModal={handleCloseRemoveModal}
      />
    </>
  );
};

export default Text;
